import { layoutSlice } from './slice';

export * from './layout';

const Reducer = layoutSlice.reducer;
const Actions = layoutSlice.actions;

export { Reducer, Actions };
